module.exports = __webpack_public_path__ + "static/media/mainbanner.aa38974f.png";